import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Search, Filter, PlusCircle, ArrowUpDown, Loader2, Edit, Eye } from "lucide-react";
import "./LandingPage.scss";
import StatCard from "../Card/StatCard.jsx";
import MiniBarChart from "../Charts/MiniBarChart";
import axios from 'axios'
import heartLoading from "../../../assests/heartLoading.gif"
import ProductViewModal from "./ProductViewModal.jsx";
import MuiDataTable from "./MuiDataTable.jsx";
import { Snackbar, Alert } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import preloader from "../../../assests/preloader1.gif";

const LandingPage = () => {
  
  const [toast, setToast] = React.useState({ open: false, message: '', severity: 'success' });
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterParentDomain, setFilterParentDomain] = useState("");
  const [filterNestedDomain, setFilterNestedDomain] = useState("");
  const [filterSubDomain, setFilterSubDomain] = useState("");
  const [filterProduct, setFilterProduct] = useState("");

  const [filterScore, setFilterScore] = useState("");
  const [loading, setLoading] = useState(true);
  const [productsLoading, setProductsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [metrics, setMetrics] = useState({
    totalAssets: 0,
    totalQualityRules: 0,
    activeAssets: 0,
    activeRulesExecuted: 0,
    activeRulesFailed: 0,
  });
  const [dataAssets, setDataAssets] = useState([]);
  const [selectedView, setSelectedView] = useState("products");
  const [myDataAssets, setMyDataAssets] = useState([])
  const [allDataAssets, setAllDataAssets] = useState([])
  const [products, setProducts] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedProductDetails, setSelectedProductDetails] = useState(null);
  const [isViewingDetails, setIsViewingDetails] = useState(false);
  const [viewingProductId, setViewingProductId] = useState(null);

  useEffect(() => {
    getDataAsset();
    getchProductsDetails();
  }, []);



  const getDataAsset = async () => {
    setLoading(true);
    setError(null);
  
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/dashboard`, {
        headers: {
          user_email: localStorage.getItem("userId"),
        },
      });
  
      if (response?.status === 200) {
        const data = response.data;
        // console.log("response", response)
  
        // Set common metrics//
        setMetrics({
          totalAssets: data.metrics.total_assets,
          totalQualityRules: data.metrics.quality_rules,
          activeAssets: data.metrics.assets_executed,
          activeRulesExecuted: data.metrics.rules_executed,
          activeRulesFailed: data.metrics.rules_failed,
        });
  
          
          const transformedAllAssets = data?.data?.all_assets && data?.data?.all_assets.map(asset => ({
            id: asset.data_asset_id,
            name: asset.data_asset_name,
            schema: asset.description || "No description available",
            columns: asset.dq_rule_count,
            size: "N/A",
            lastUpdated: new Date(asset.last_modified).toLocaleDateString(),
            owner: asset.created_by,
            domain: asset.domain_name,
            qualityScore: asset.quality_score,
            status: asset.is_active ? "Active" : "Inactive",
            productName: asset.product_name,
            dataAssetType: asset.data_asset_type,
            country: asset.country,
            region: asset.region,
            subDomain: asset.sub_domain_name,
            parentDomainName: asset.parent_domain_name,
            createdDate: new Date(asset.created_date).toLocaleDateString(),
          }));
  
          setAllDataAssets(transformedAllAssets);
          setDataAssets(transformedAllAssets)
        // } else {
          const transformedMyAssets = data?.data?.my_assets && data?.data?.my_assets.map(asset => ({
            id: asset.data_asset_id,
            name: asset.data_asset_name,
            schema: asset.description || "No description available",
            columns: asset.dq_rule_count,
            size: "N/A",
            lastUpdated: asset.last_modified,
            owner: asset.created_by,
            domain: asset.domain_name,
            qualityScore: asset.quality_score,
            status: asset.is_active ? "Active" : "Inactive",
            productName: asset.product_name,
            dataAssetType: asset.data_asset_type,
            country: asset.country,
            region: asset.region,
            subDomain: asset.sub_domain_name,
            parentDomainName: asset.parent_domain_name,
            createdDate: new Date(asset.created_date).toLocaleDateString(),
          }));
  
          setMyDataAssets(transformedMyAssets);
        // }
      }
    } catch (err) {
      console.error("Error fetching data assets:", err);
      setError("Failed to fetch data assets. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const getchProductsDetails = async() => {
    try{
      setProductsLoading(true)
      
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/get-product-submissions`)

      if(response.status === 200 || 201){
        console.log("reponse", response)
        console.log("response data", response.data)
        setProducts(response.data)
        setProductsLoading(false)
      }
    
    }catch(e){
      setProductsLoading(false)
    }
  }
  
  const unfilteredData = selectedView === "products" ? products : allDataAssets;

  // Extract unique values from dashboard API response for cascading filters
  const parentDomainOptions = useMemo(() => {
    let filteredParentDomains = allDataAssets;
    
    // Filter by any selected filter
    if (filterNestedDomain) {
      filteredParentDomains = filteredParentDomains.filter(asset => asset.domain === filterNestedDomain);
    }
    if (filterSubDomain) {
      filteredParentDomains = filteredParentDomains.filter(asset => asset.subDomain === filterSubDomain);
    }
    if (filterProduct) {
      filteredParentDomains = filteredParentDomains.filter(asset => asset.productName === filterProduct);
    }
    
    const uniqueParentDomains = [...new Set(filteredParentDomains.map(asset => asset.parentDomainName))].filter(Boolean);
    return uniqueParentDomains.map(pd => ({ value: pd, label: pd }));
  }, [allDataAssets, filterNestedDomain, filterSubDomain, filterProduct]);

  const domainOptions = useMemo(() => {
    let filteredDomains = allDataAssets;
    
    // Filter by any selected filter
    if (filterParentDomain) {
      filteredDomains = filteredDomains.filter(asset => asset.parentDomainName === filterParentDomain);
    }
    if (filterSubDomain) {
      filteredDomains = filteredDomains.filter(asset => asset.subDomain === filterSubDomain);
    }
    if (filterProduct) {
      filteredDomains = filteredDomains.filter(asset => asset.productName === filterProduct);
    }
    
    const uniqueDomains = [...new Set(filteredDomains.map(asset => asset.domain))].filter(Boolean);
    return uniqueDomains.map(d => ({ value: d, label: d }));
  }, [allDataAssets, filterParentDomain, filterSubDomain, filterProduct]);

  const subDomainOptions = useMemo(() => {
    let filteredSubDomains = allDataAssets;
    
    // Filter by any selected filter
    if (filterParentDomain) {
      filteredSubDomains = filteredSubDomains.filter(asset => asset.parentDomainName === filterParentDomain);
    }
    if (filterNestedDomain) {
      filteredSubDomains = filteredSubDomains.filter(asset => asset.domain === filterNestedDomain);
    }
    if (filterProduct) {
      filteredSubDomains = filteredSubDomains.filter(asset => asset.productName === filterProduct);
    }
    
    const uniqueSubDomains = [...new Set(filteredSubDomains.map(asset => asset.subDomain))].filter(Boolean);
    return uniqueSubDomains.map(sd => ({ value: sd, label: sd }));
  }, [allDataAssets, filterParentDomain, filterNestedDomain, filterProduct]);

  const productOptions = useMemo(() => {
    let filteredProducts = allDataAssets;
    
    // Filter by any selected filter
    if (filterParentDomain) {
      filteredProducts = filteredProducts.filter(asset => asset.parentDomainName === filterParentDomain);
    }
    if (filterNestedDomain) {
      filteredProducts = filteredProducts.filter(asset => asset.domain === filterNestedDomain);
    }
    if (filterSubDomain) {
      filteredProducts = filteredProducts.filter(asset => asset.subDomain === filterSubDomain);
    }
    
    const productNames = [...new Set(filteredProducts.map(asset => asset.productName))].filter(Boolean);
      return productNames.map(name => ({ value: name, label: name }));
  }, [allDataAssets, filterParentDomain, filterNestedDomain, filterSubDomain]);

  const dataSource = unfilteredData.filter((item) => {
    // Only apply data asset filters when not in products view
    if (selectedView === "products") {
      return true; // No filtering for products view
    }
    
    const matchesParentDomain = filterParentDomain ? item.parentDomainName === filterParentDomain : true;
    const matchesNestedDomain = filterNestedDomain ? item.domain === filterNestedDomain : true;
    const matchesSubDomain = filterSubDomain ? item.subDomain === filterSubDomain : true;
    const matchesProduct = filterProduct ? item.productName === filterProduct : true;

    let matchesScore = true;
    if (filterScore === "gt90") {
      matchesScore = item.qualityScore > 90;
    } else if (filterScore === "gt80") {
      matchesScore = item.qualityScore > 80;
    } else if (filterScore === "gt60") {
      matchesScore = item.qualityScore > 60;
    } else if (filterScore === "lt50") {
      matchesScore = item.qualityScore < 50;
    } else if (filterScore === "gt50") {
      matchesScore = item.qualityScore > 50;
    }

    const matchesSearch = searchQuery ? item.name?.toLowerCase().includes(searchQuery.toLowerCase()) : true;

    return matchesParentDomain && matchesNestedDomain && matchesSubDomain && matchesProduct && matchesScore && matchesSearch;
  });

  const productDataSource = products.filter(product => 
    searchQuery ? product.productName.toLowerCase().includes(searchQuery.toLowerCase()) : true
  );

  const currentDataSource = selectedView === "products" ? productDataSource : dataSource;

  const rowsPerPage = 10; // Fixed to 10 items per page
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = currentDataSource.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.max(1, Math.ceil(currentDataSource.length / rowsPerPage));



 

  const handleViewProduct = (product) => {
    
    if (product) {
      setSelectedProductDetails(product);
      setShowViewModal(true);
    }
  };

  const handleDeleteProduct = async(product_id) => { 
    try{
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/delete-product/${product_id}`)
      if (response?.status === 200) {
        setToast({ open: true, message: 'Product deleted successfully.', severity: 'success' });
        getchProductsDetails();
      }
    } catch (err) {
      setToast({ open: true, message: 'Failed to delete product.', severity: 'error' });
    }
  }

  // Remove useEffect for products since we'll use dummy data
 

  // Update the view toggle handler to set dummy products
  const handleViewToggle = (view) => {
    setSelectedView(view);
    if (view === "products") {
      // If products haven't been loaded yet, trigger the API call
      if (products.length === 0) {
        getchProductsDetails();
      }
    } else if (view === "all") {
      setDataAssets(allDataAssets);
    } else {
      setDataAssets(myDataAssets);
    }
  };

  // Bidirectional filter handlers
  const handleParentDomainChange = (value) => {
    setFilterParentDomain(value);
    
    // Auto-populate other fields if only one option remains
    if (value) {
      const filteredAssets = allDataAssets.filter(asset => asset.parentDomainName === value);
      
      // Auto-populate domain if only one option
      const uniqueDomains = [...new Set(filteredAssets.map(asset => asset.domain))].filter(Boolean);
      if (uniqueDomains.length === 1) {
        setFilterNestedDomain(uniqueDomains[0]);
      }
      
      // Auto-populate sub-domain if only one option
      const uniqueSubDomains = [...new Set(filteredAssets.map(asset => asset.subDomain))].filter(Boolean);
      if (uniqueSubDomains.length === 1) {
        setFilterSubDomain(uniqueSubDomains[0]);
      }
      
      // Auto-populate product if only one option
      const uniqueProducts = [...new Set(filteredAssets.map(asset => asset.productName))].filter(Boolean);
      if (uniqueProducts.length === 1) {
        setFilterProduct(uniqueProducts[0]);
      }
    }
  };

  const handleDomainChange = (value) => {
    setFilterNestedDomain(value);
    
    // Auto-populate other fields if only one option remains
    if (value) {
      let filteredAssets = allDataAssets.filter(asset => asset.domain === value);
      
      // Apply parent domain filter if selected
      if (filterParentDomain) {
        filteredAssets = filteredAssets.filter(asset => asset.parentDomainName === filterParentDomain);
      }
      
      // Auto-populate parent domain if only one option
      const uniqueParentDomains = [...new Set(filteredAssets.map(asset => asset.parentDomainName))].filter(Boolean);
      if (uniqueParentDomains.length === 1) {
        setFilterParentDomain(uniqueParentDomains[0]);
      }
      
      // Auto-populate sub-domain if only one option
      const uniqueSubDomains = [...new Set(filteredAssets.map(asset => asset.subDomain))].filter(Boolean);
      if (uniqueSubDomains.length === 1) {
        setFilterSubDomain(uniqueSubDomains[0]);
      }
      
      // Auto-populate product if only one option
      const uniqueProducts = [...new Set(filteredAssets.map(asset => asset.productName))].filter(Boolean);
      if (uniqueProducts.length === 1) {
        setFilterProduct(uniqueProducts[0]);
      }
    }
  };

  const handleSubDomainChange = (value) => {
    setFilterSubDomain(value);
    
    // Auto-populate other fields if only one option remains
    if (value) {
      let filteredAssets = allDataAssets.filter(asset => asset.subDomain === value);
      
      // Apply existing filters
      if (filterParentDomain) {
        filteredAssets = filteredAssets.filter(asset => asset.parentDomainName === filterParentDomain);
      }
      if (filterNestedDomain) {
        filteredAssets = filteredAssets.filter(asset => asset.domain === filterNestedDomain);
      }
      
      // Auto-populate parent domain if only one option
      const uniqueParentDomains = [...new Set(filteredAssets.map(asset => asset.parentDomainName))].filter(Boolean);
      if (uniqueParentDomains.length === 1) {
        setFilterParentDomain(uniqueParentDomains[0]);
      }
      
      // Auto-populate domain if only one option
      const uniqueDomains = [...new Set(filteredAssets.map(asset => asset.domain))].filter(Boolean);
      if (uniqueDomains.length === 1) {
        setFilterNestedDomain(uniqueDomains[0]);
      }
      
      // Auto-populate product if only one option
      const uniqueProducts = [...new Set(filteredAssets.map(asset => asset.productName))].filter(Boolean);
      if (uniqueProducts.length === 1) {
        setFilterProduct(uniqueProducts[0]);
      }
    }
  };

  const handleProductChange = (value) => {
    setFilterProduct(value);
    
    // Auto-populate other fields if only one option remains
    if (value) {
      let filteredAssets = allDataAssets.filter(asset => asset.productName === value);
      
      // Auto-populate parent domain if only one option
      const uniqueParentDomains = [...new Set(filteredAssets.map(asset => asset.parentDomainName))].filter(Boolean);
      if (uniqueParentDomains.length === 1) {
        setFilterParentDomain(uniqueParentDomains[0]);
      }
      
      // Auto-populate domain if only one option
      const uniqueDomains = [...new Set(filteredAssets.map(asset => asset.domain))].filter(Boolean);
      if (uniqueDomains.length === 1) {
        setFilterNestedDomain(uniqueDomains[0]);
      }
      
      // Auto-populate sub-domain if only one option
      const uniqueSubDomains = [...new Set(filteredAssets.map(asset => asset.subDomain))].filter(Boolean);
      if (uniqueSubDomains.length === 1) {
        setFilterSubDomain(uniqueSubDomains[0]);
      }
    }
  };

  const productColumns = [
    { id: 'productName', label: 'Product Name', sortable: true },
    { id: 'productDescription', label: 'Description', sortable: true },
    { id: 'version', label: 'Version', sortable: true },
    { id: 'status', label: 'Status', sortable: true },
    { id: 'currentPhase', label: 'Current Phase', sortable: true},
    { id: 'versioning', label: 'Versioning', sortable: true},
    { id: 'actions', label: 'Actions', sortable: false }
  ];
  const [role, setRole] = React.useState();

  const getRole = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const url  = `${process.env.REACT_APP_API_URL}/user/id/${userId}`;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      // Axios automatically parses JSON, so no need for response.json()
      setRole(response.data.role_name);
    } catch (error) {
      console.error("Error fetching role:", error);
    }
  };

  React.useEffect(() => {
    getRole();
  })

  const dataAssetColumns = [
    { id: 'name', label: 'Assets Name', sortable: true },
    { id: 'schema', label: 'Description', sortable: true },
    { id: 'columns', label: 'No of DQ Rules', sortable: true },
    { id: 'qualityScore', label: 'Quality Score', sortable: true },
    { id: 'lastUpdated', label: 'Last Updated', sortable: true },
    { id: 'createdDate', label: 'Created Date', sortable: true }
  ];

  if (loading || productsLoading) {
    return (
   <div style={{
       position: 'fixed',
       top: 0,
       left: 0,
       right: 0,
       bottom: 0,
       backgroundColor: 'white',
       display: 'flex',
       alignItems: 'center',
       justifyContent: 'center',
       zIndex: 9999,
       width: '100vw',
       height: '100vh'
     }}>
       <div style={{
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center',
         gap: '12px'
       }}>
         <img src={preloader} alt="Loading..." width={200} />
         <span style={{
           color: '#374151',
           fontSize: '20px',
           fontWeight: '500'
         }}>
           Hang tight! The resources are loading...
         </span>
       </div>
     </div>
    );
  }

  if (error) {
    return (
      <div className="error-container ">
        <p className="error-message">{error}</p>
        <button onClick={getDataAsset} className="retry-button">
          Retry
        </button>
      </div>
    );
  }

  return (
    <div
      style={{ paddingLeft: "0px", paddingRight: "0px" }}
      className="dashboard-container">
      <Snackbar open={toast.open} autoHideDuration={3000} onClose={() => setToast({ ...toast, open: false })} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <Alert onClose={() => setToast({ ...toast, open: false })} severity={toast.severity} sx={{ width: '100%' }}>
          {toast.message}
        </Alert>
      </Snackbar>
          


      <div className="dashboard-main ">
        <div className="dashboard-header px-4">
        <div className="font-bold font-family-poppins pt-2  text-[24px] text-[#424242]">Overview</div>
        <p className="pb-4">View all essential information about this asset in one place</p>

          

          <div className="dashboard-actions"  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',}} >
          <div className="view-toggle" style={{display:'flex',gap:'10px'}}>
           
                        {selectedView !== "products" && (
                <>
                  <button
                    className="filter-button"
                    onClick={() => setShowFilters(!showFilters)}
                  >
                    <Filter className="icon" />
                    <span>Filter</span>
                  </button>
                  {(filterParentDomain || filterNestedDomain || filterSubDomain || filterProduct || filterScore) && (
                    <button
                      className="reset-filter-button"
                      onClick={() => {
                        setFilterParentDomain("");
                        setFilterNestedDomain("");
                        setFilterSubDomain("");
                        setFilterProduct("");
                        setFilterScore("");
                      }}
                    >
                      Reset Filters
                    </button>
                  )}
                </>
              )}
               {(role === 'Data Steward' || role === "Admin" || role === "Domain Owner" || role === "Product Owner") ? (
            <>
             {selectedView === "products" ? (
              <Link to="/product-onboarding" className="onboard-button  h-[50px] w-[160px] rounded-md border border-[#818181] ">
                {/* <PlusCircle className="icon" /> */}
                <span> <AddIcon /> New Product</span>

              </Link>
            ) : (
              <Link to="/product-onboarding" className="onboard-button  h-[50px] w-[160px] rounded-md border border-[#818181]">
                {/* <PlusCircle className="icon" /> */}
                <span> <AddIcon /> New Product</span>
              </Link>
            )}
            </>
           ) : (
            <>
            
            {selectedView === "products" ? (
              <button disabled style={{color:"#333",cursor:"not-allowed",padding:'4px 6px'}} className="onboard-button bg-gray-100 h-[50px] w-[140px] rounded-md border border-[#818181] ">
                {/* <PlusCircle className="icon" /> */}
                <span><AddIcon /> New Product</span>
              </button>
            ) : (
              <button disabled style={{color:"#333",cursor:"not-allowed",padding:'4px 6px',}} className="onboard-button  bg-gray-100 h-[50px] w-[140px] rounded-md border border-[#818181]">
                {/* <PlusCircle className="icon" /> */}
                <span><AddIcon /> New Product</span>
              </button>
            )}
            
            </>
           )}

             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div className="search-box ">
                <Search className="search-icon" />
                <input
                  type="text"
                  placeholder={selectedView === "products" ? "Search for Products" : "Search for Data Assets"}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

          
          </div>
          </div>

          
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
         

        
      <div className="flex items-center justify-center gap-2 ">
  {/* Previous Button */}
  <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className={`px-3 py-2 border rounded text-base font-medium ${
      currentPage === 1
        ? 'opacity-50 cursor-not-allowed text-gray-400 bg-gray-50'
        : 'text-gray-700 bg-white hover:bg-gray-100'
    }`}
  >
    Previous
  </button>

  {/* Page Numbers */}
  {(() => {
    const pageButtons = [];
    const totalToShow = 5;

    let start = Math.max(1, currentPage - Math.floor(totalToShow / 2));
    let end = start + totalToShow - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - totalToShow + 1);
    }

    if (start > 1) pageButtons.push(1);
    if (start > 2) pageButtons.push("...");

    for (let i = start; i <= end; i++) pageButtons.push(i);

    if (end < totalPages - 1) pageButtons.push("...");
    if (end < totalPages) pageButtons.push(totalPages);

    return pageButtons.map((p, idx) =>
      p === "..." ? (
        <span key={idx} className="px-2 text-gray-500">
          ...
        </span>
      ) : (
        <button
          key={idx}
          onClick={() => setCurrentPage(p)}
          className={`px-3 py-2 border rounded text-base font-medium ${
            currentPage === p
              ? 'bg-[#bb1ccc;] text-white'
              : 'bg-white text-gray-700 hover:bg-gray-100'
          }`}
        >
          {p}
        </button>
      )
    );
  })()}

  {/* Next Button */}
  <button
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className={`px-3 py-2 border rounded text-base font-medium ${
      currentPage === totalPages
        ? 'opacity-50 cursor-not-allowed text-gray-400 bg-gray-50'
        : 'text-gray-700 bg-white hover:bg-gray-100'
    }`}
  >
    Next
  </button>
</div>



       
        </div>
          </div>

          {showFilters && selectedView !== "products" && (
            <div className="filters-panel">
              <div className="filter-group">
                <label>Parent Domain</label>
                <select
                  value={filterParentDomain}
                  onChange={(e) => handleParentDomainChange(e.target.value)}
                >
                  <option value="">All Parent Domains</option>
                  {parentDomainOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div className="filter-group">
                <label>Domain</label>
                <select
                  value={filterNestedDomain}
                  onChange={(e) => handleDomainChange(e.target.value)}
                >
                  <option value="">All Domains</option>
                  {domainOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div className="filter-group">
                <label>Sub Domain</label>
                <select
                  value={filterSubDomain}
                  onChange={(e) => handleSubDomainChange(e.target.value)}
                >
                  <option value="">All Sub Domains</option>
                  {subDomainOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div className="filter-group">
                <label>Product</label>
                <select
                  value={filterProduct}
                  onChange={(e) => handleProductChange(e.target.value)}
                >
                  <option value="">All Products</option>
                  {productOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div className="filter-group">
                <label>Quality Score</label>
                <select
                  value={filterScore}
                  onChange={(e) => setFilterScore(e.target.value)}
                >
                  <option value="">All Scores</option>
                  <option value="gt90">Above 90%</option>
                  <option value="gt80">Above 80%</option>
                  <option value="gt60">Above 60%</option>
                  <option value="gt50">Above 50%</option>
                  <option value="lt50">Below 50%</option>
                </select>
              </div>

            </div>
          )}
        </div>

        <div className="border-b border-gray-300 mb-4"></div>
        <div className="px-4" >

        <div className="table-container">
          <MuiDataTable
            data={currentRows}
            columns={selectedView === "products" ? productColumns : dataAssetColumns}
            onView={handleViewProduct}
            onDelete={handleDeleteProduct}
            selectedView={selectedView}
            searchQuery={searchQuery}
            userRole={role}
          />
        </div>

    
        </div>
      </div>
      {showViewModal && (
        <ProductViewModal
          open={showViewModal}
          onClose={() => setShowViewModal(false)}
          product={selectedProductDetails}
        />
      )}
    </div>
  );
};

export default LandingPage;
